import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  url,
 
}) => (
  <Helmet>
    {/* Basic SEO */}
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="keywords" content={keywords} />
    <link rel="canonical" href={url} />

    {/* Open Graph / Facebook / LinkedIn */}
    <meta property="og:type" content="website" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={url} />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
 
    <meta name="twitter:url" content={url} />

    {/* Structured data for social profiles */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Restaurant",
        name: "Vaikunta Maha Ruchulu",
        url: url,
        sameAs: [
          "https://www.facebook.com/VaikuntaMahaRuchulu",
          "https://www.instagram.com/VaikuntaMahaRuchulu",
          "https://x.com/VaikuntaVeg",
          "https://g.page/vaikuntamaharuchulu",
          "https://www.youtube.com/@VaikuntaMahaRuchulu"
        ],
      })}
    </script>
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "Vaikunta Maha Ruchulu",
        url: url,
        hasPart: [
          {
            "@type": "WebPage",
            name: "Services",
            url: `${url}/services`
          },
          {
            "@type": "WebPage",
            name: "Contact",
            url: `${url}/contact`
          }
        ]
      })}
    </script>
  </Helmet>
);

export default SEO;
